(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grilledimage"] && !Shopify.designMode) return;
  try {
    
/* Aucun JS requis pour la grille. Ajoutez si besoin d’interactions. */

  } catch(e) { console.error(e); }
})();
})();
